import { Moment } from 'moment';

import { ItemActionBase } from 'app/buffer-graph/models/item-actions/item-action-base';

export class ItemAction extends ItemActionBase {
    constructor(
        id: string,
        actionSeason: string,
        status: string,
        public readonly type: string,
        purchaseDate: string,
        //purchaseDate: Moment,
        startDate: string,
        //startDate: Moment,
        endDate: string,
        //endDate: Moment,
        saleChangeRatio: string/*number*/,
        saleIncrease: string/*number*/,
        public readonly safetyStock: string/*number*/,
        public readonly averageSaleOverReplTime: string/*number*/,
        public readonly bufferOld: string/*number*/,
        public readonly bufferNew: string/*number*/,
        public readonly bufferAfterAction: string/*number*/,
        replenishment: string,
        actionOut: string,
        public readonly nestedAction: string,
        importDate: string,
        //importDate: Moment,
        documentstring/*number*/: string) {
        super(id,
            actionSeason,
            status,
            purchaseDate,
            startDate,
            endDate,
            saleChangeRatio,
            saleIncrease,
            replenishment,
            actionOut,
            importDate,
            documentstring/*number*/);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-action.ts